import ContactForm from '../components/ContactForm'
export default function Contact() {
  return (
    <div className="container mx-auto px-4 py-12">
      <h1 className="text-5xl font-bold text-gray-900 mb-6">Contact Us</h1>
        <p className="text-xl text-gray-600 mb-12">
          Get in touch with us. We'd love to hear from you.
        </p>
        
        <div className="grid md:grid-cols-2 gap-12">
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Send Us a Message</h2>
            <ContactForm
            websiteId="51ceaf5c-438f-4d9c-b6fe-ce32b25d296a" />
          </div>
          
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Contact Information</h2>
            <div className="space-y-4 text-gray-600">
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Email</h3>
                <p>We'll respond to your message promptly.</p>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Response Time</h3>
                <p>We typically respond within 24 hours.</p>
              </div>
            </div>
          </div>
        </div>

    </div>
  );
}
